import { useApiMutation } from '../../../hooks/useApiMutation';
import { UseApiMutationOptions } from '../../logBooks/types/loogBookTypes';
import { deleteLogbook } from '../api/listApi';

type MutationResponse = { message: string };
type MutationVariables = string;

export const useDeleteLogbook = (
  options?: UseApiMutationOptions<MutationResponse, Error, MutationVariables>,
  invalidateQueryKey?: any
) => {
  return useApiMutation<MutationResponse, Error, MutationVariables>(deleteLogbook, {
    successMessage: 'Logbook deleted successfully',
    errorMessage: 'Failed to delete logbook',
    invalidateQueryKeys: [invalidateQueryKey],
    ...options,
  });
};